import {FormControl, InputLabel, Button, Divider, MenuItem, Select, TextField, Grid} from '@material-ui/core';
import States from 'ApplicationEntry/models/States';
import React, {useState} from 'react';
import './SecondaryAddressee.sass';
import {useDispatch} from 'react-redux';
import {
  changeBusinessArea,
  changeStatus,
  changeWorkType,
  changeCoCode,
  changePolicyNumber,
  changeBankNumber,
  changeFirstName,
  changeLastName,
  changeSocialSecurityNumber,
  changeAgent,
  changeCaseNumber,
  changePriorityIncrease,
  changeStateSigned,
  changePayorNumber,
  updatePolicyRecordDetails,
  changeAsyncPolicyNumber,
} from 'ApplicationEntry/ducks/policyRecord';
import {PolicyRecord} from 'ApplicationEntry/models/PolicyRecord';
import './PolicyDetailsTab.sass';
import {maskTaxId, unMaskTaxId} from 'Shared/utilities/taxIdMasker';
import {Loading} from 'Core/models/Async';

type PolicyRecordDetails = {
  policyRecord: PolicyRecord;
};

const PolicyRecordDetails = (props: PolicyRecordDetails) => {
  const dispatch = useDispatch();

  const [bankNumberLabel, setBankNumberLabel] = useState<HTMLLabelElement | null>();
  const [stateLabel, setStateLabel] = useState<HTMLLabelElement | null>();
  return (
    <form noValidate autoComplete="off" className="policy-details-section">
      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <TextField
            id="business-area"
            label="Business Area"
            variant="filled"
            placeholder="Business Area"
            margin="normal"
            fullWidth
            inputProps={{readOnly: true}}
            className="policy-details-section__field"
            value={props.policyRecord.businessArea.value}
            onChange={e => dispatch(changeBusinessArea(e.target.value))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="status-name"
            label="Status"
            variant="filled"
            placeholder="Status"
            margin="normal"
            fullWidth
            inputProps={{readOnly: true}}
            className="policy-details-section__field"
            value={props.policyRecord.status.value}
            onChange={e => dispatch(changeStatus(e.target.value))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="work-type"
            label="Work Type"
            variant="filled"
            placeholder="Work Type"
            margin="normal"
            fullWidth
            inputProps={{readOnly: true}}
            className="policy-details-section__field"
            value={props.policyRecord.workType.value}
            onChange={e => dispatch(changeWorkType(e.target.value))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="co-code"
            label="Co. Code"
            variant="filled"
            placeholder="Co. Code"
            margin="normal"
            fullWidth
            inputProps={{readOnly: true}}
            className="policy-details-section__field"
            value={props.policyRecord.coCode.value}
            onChange={e => dispatch(changeCoCode(e.target.value))}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            id="policy-number"
            label="Policy Number"
            variant="outlined"
            placeholder="Policy Number"
            margin="normal"
            fullWidth
            inputProps={{maxLength: 8}}
            className="policy-details-section__field"
            value={
              props.policyRecord.policyNumber.key === 'UserAssignedPolicyNumber'
                ? props.policyRecord.policyNumber.value
                : props.policyRecord.policyNumber.key === 'Loaded'
                ? props.policyRecord.policyNumber.Data
                : ''
            }
            onChange={e => {
              dispatch(changePolicyNumber(e.target.value));
            }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl variant="outlined" className="policy-details-section__field">
            <InputLabel ref={el => setBankNumberLabel(el)} id="select-bank-number-label">
              Bank No.
            </InputLabel>
            <Select
              labelWidth={bankNumberLabel?.clientWidth}
              labelId="select-bank-number-label"
              id="select-bank-number"
              value={props.policyRecord.bankNumber.value}
              onChange={e => dispatch(changeBankNumber(e.target.value as string))}
            >
              <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              <MenuItem value="Y">Y</MenuItem>
              <MenuItem value="N">N</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="policy-record-SSN"
            label="SSN"
            variant="outlined"
            placeholder="XXX-XX-XXXX"
            margin="normal"
            inputProps={{maxLength: 11}}
            className="policy-details-section__field"
            value={maskTaxId(props.policyRecord.socialSecurityNumber.value)}
            onChange={e => dispatch(changeSocialSecurityNumber(unMaskTaxId(e.target.value)))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="policy-record-first-name"
            label="First Name"
            variant="outlined"
            placeholder="Enter First Name"
            margin="normal"
            className="policy-details-section__field"
            value={props.policyRecord.firstName.value}
            onChange={e => dispatch(changeFirstName(e.target.value))}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            id="policy-record-last-name"
            label="Last Name"
            variant="outlined"
            placeholder="Enter Last Name"
            margin="normal"
            className="policy-details-section__field"
            value={props.policyRecord.lastName.value}
            onChange={e => dispatch(changeLastName(e.target.value))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="policy-record-agent"
            label="Agent"
            variant="outlined"
            placeholder="Enter Agent"
            margin="normal"
            inputProps={{maxLength: 5}}
            className="policy-details-section__field"
            value={props.policyRecord.agent.value}
            onChange={e => dispatch(changeAgent(e.target.value))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="policy-record-case"
            label="Case"
            variant="outlined"
            placeholder="Enter Case"
            margin="normal"
            inputProps={{maxLength: 5}}
            className="policy-details-section__field"
            value={props.policyRecord.caseNumber.value}
            onChange={e => dispatch(changeCaseNumber(e.target.value))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="policy-record-priority-increase"
            label="Priority Increase"
            variant="outlined"
            placeholder="Enter Priority Increase"
            inputProps={{
              maxLength: 3,
            }}
            value={props.policyRecord.priorityIncrease}
            className="policy-details-section__field"
            type="number"
            onChange={e => dispatch(changePriorityIncrease(parseInt(e.target.value)))}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <FormControl variant="outlined" className="policy-details-section__field">
            <InputLabel ref={el => setStateLabel(el)} id="select-state-signed-label">
              State Signed
            </InputLabel>
            <Select
              labelWidth={stateLabel?.clientWidth}
              labelId="select-state-signed-label"
              id="select-state-signed"
              value={props.policyRecord.stateSigned.value}
              onChange={e => dispatch(changeStateSigned(e.target.value as string))}
            >
              {States.map(stateCode => (
                <MenuItem value={stateCode} key={stateCode}>
                  {stateCode}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="policy-record-payor-number"
            label="Payor Number"
            variant="outlined"
            placeholder="Enter Payor Number"
            inputProps={{maxLength: 10}}
            className="policy-details-section__field"
            value={props.policyRecord.payorNumber.value}
            onChange={e => dispatch(changePayorNumber(e.target.value))}
          />
        </Grid>
      </Grid>

      <Divider className="application-form__actions-divider" />
      <div>
        <Button
          variant="contained"
          className="application-wizard__next-step-button"
          onClick={() => {
            dispatch(changeAsyncPolicyNumber(new Loading()));
            dispatch(updatePolicyRecordDetails(props.policyRecord));
          }}
        >
          Update
        </Button>
      </div>
    </form>
  );
};

export default PolicyRecordDetails;
